"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongParamsPassedToMethodException = void 0;
class WrongParamsPassedToMethodException extends Error {
    static CODE = 'WRONG_PARAMS_PASSED_TO_METHOD';
    constructor() {
        super(WrongParamsPassedToMethodException.CODE);
    }
}
exports.WrongParamsPassedToMethodException = WrongParamsPassedToMethodException;
